import { GetExtranetNewslettersQueryDto } from '@pharmac-extranet/extranet-api'
import { api } from '../../services/HttpService'

export const newslettersQueryKeyFactory = {
  all: (...params: (undefined | any)[]) => ['__getNewsletters', params],
  getOne: (newsletterId?: number, ...params: (any | undefined)[]) => [
    '__getNewsletter',
    newsletterId,
    ...params,
  ],
}

export const getNewslettersQuery = (dto?: GetExtranetNewslettersQueryDto) => {
  return {
    queryKey: newslettersQueryKeyFactory.all(dto),
    queryFn: async () => await api.newsletters.getNewsletters(dto),
  }
}

export const getNewsletterQuery = (newsletterId?: number, ...params: (undefined | any)[]) => ({
  queryKey: newslettersQueryKeyFactory.getOne(newsletterId, params),
  queryFn: async () => await api.newsletters.getNewsletterById(newsletterId as number),
  enabled: !!newsletterId && typeof newsletterId === 'number',
})
